import { AfterViewChecked, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject, takeUntil } from 'rxjs';
import { Asset } from 'src/app/core/models/insight-configuration.model';
import { GetAlgorithmAssetList, SetSelectedAssetList } from 'src/app/core/store/ewb-configuration/ewb-configuration.action';
import _ from 'lodash';

@Component({
  selector: 'app-ewb-asset-selection-popup',
  templateUrl: './ewb-asset-selection-popup.component.html',
  styleUrls: ['./ewb-asset-selection-popup.component.scss']
})
export class EwbAssetSelectionPopupComponent implements OnInit,AfterViewChecked, OnDestroy{
  public assetList: Asset[]
  public disabledAssetList: Asset[] = [];
  public disabledSelectAll: boolean = false;
  public assetsLoading: boolean = true;

  public count = 0
  public allSelected: boolean = false;
  public someSelected: boolean = false;
  public selectedAlgorithm: any;

  public selectedPlant: any;
  public modelList: any;

  public unsubscribe = new Subject<void>();

  form: UntypedFormGroup;

  constructor(
    public modalRef: BsModalRef,
    public store: Store,
    private readonly fb: UntypedFormBuilder,
    private readonly cdr: ChangeDetectorRef,
    public router: Router
  ) {
  }

  ngOnInit(): void {
    this.getSelectedPlant();
    this.initiateForm();
    this.getAssetList();
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public selectAll(selected: boolean) {
    this.allSelected = selected
    if (this.assetList === null) {
      return;
    }
    this.assetList.forEach(asset => asset.selected = selected);
    this.checkSomeSelected();
  }

  public onAssetSelected() {
    this.allSelected = this.assetList !== null && this.assetList.length > 0 && this.assetList.every(asset => asset.selected);
    this.checkSomeSelected();
  }

  public checkSomeSelected() {
    this.someSelected = this.assetList.filter(asset => asset.selected).length > 0 && !this.allSelected;
    this.count = this.assetList.filter(asset => asset.selected).length;
  }

  public initiateForm(): void {
    this.form = this.fb.group({
      asset: this.fb.array([]),
    });
  }

  public getSelectedPlant() {
    //to get the selected Plant option
    this.selectedPlant = this.store.selectSnapshot(state => state.configurations.selectedPlant);
  }

  public getAssetList() {
    this.assetList = this.store.selectSnapshot(state => state.configurations.ewb.assetSelection)
    this.filterSelected();
    this.onAssetSelected();
    if (this.assetList.length === 0) {
      this.store.select(state => state.configurations?.ewb?.modelList).pipe(takeUntil(this.unsubscribe)).subscribe(algorithm => {
        this.modelList = algorithm;
        this.store.dispatch(new GetAlgorithmAssetList(this.modelList, false))
          .subscribe((state) => {
            this.assetList = state.configurations.ewb.assetSelection
            this.filterSelected();
            this.onAssetSelected();
            this.assetsLoading = false;
          })
      })
    } else {
      this.assetsLoading = false;
    }
  }

  public filterSelected() {
    const selectedAssets = this.store.selectSnapshot(state => state.configurations.ewb.assetsSelected);
    const activeAssetList = this.assetList
      .filter((asset) => !asset.configured)
      .map((asset) => {
        asset.selected = !!selectedAssets.find(selectedAsset => selectedAsset.assetId === asset.assetId)
        return asset;
      })

    const disabledAssetList = this.assetList.filter((asset) => asset.configured);

    this.assetList = activeAssetList;
    this.disabledSelectAll = this.assetList.length === 0;
    this.disabledAssetList = disabledAssetList;
  }

  submit() {
    const selectedAssets = _.cloneDeep(this.assetList.filter(asset => asset.selected))
    this.store.dispatch(new SetSelectedAssetList(selectedAssets)).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
      this.modalRef.hide();
    })
    this.store.dispatch(new GetAlgorithmAssetList(this.modelList, false))
  }

  public onCloseButtonClick(): void {
    this.modalRef.hide();

    if (this.assetList.length === 0) {
      this.router.navigateByUrl('/home')
    }
  }
}
